export default __webpack_public_path__ + "static/media/meals.5a16bc08.jpg";